import styled from "styled-components";
import Variables from "../../assets/styleVariables";

const COLORS = {
  primary: {
    background: Variables.colors.primary_100,
    color: Variables.colors.primary
  },
  success: {
    background: Variables.colors.green_100,
    color: Variables.colors.green_800
  },
  warning: {
    background: Variables.colors.yellow_100,
    color: Variables.colors.red
  },
  secondary: {
    background: Variables.colors.complementary_300,
    color: Variables.colors.complementary_700
  },
  outline: {
    background: Variables.colors.complementary,
    color: Variables.colors.complementary_900
  },
  normal: {
    background: Variables.colors.complementary_250,
    color: Variables.colors.complementary_700
  }
};

export const Box = styled.div`
  position: relative;
  //width: 100%;
  //height: inherit; //todo comment for select option for accounting code
  height: 40px;
  border: 1px solid
    ${props => {
      switch (props.status) {
        case "warning":
          return Variables.colors.yellow_500;
        case "error":
          return Variables.colors.red_600;
        case "success":
          return Variables.colors.green;
        default:
          return Variables.colors.complementary_450;
      }
    }};
  background-color: inherit;

  .notice {
    margin-bottom: 8px;
    display: block;
    padding: 4px 0;
    font-size: ${Variables.font_sizes.x_small};
    color: ${Variables.colors.red_600};
  }

  .label {
    position: absolute;
    right: 8px;
    font-size: ${Variables.font_sizes.x2_medium};
    transition: 0.1s;
    top: 10px;
    padding: 0 6px;
    color: ${props => {
      switch (props.status) {
        case "warning":
          return Variables.colors.yellow_500;
        case "error":
          return Variables.colors.red_600;
        case "success":
          return Variables.colors.green;
        default:
          return Variables.colors.complementary_700;
      }
    }};
    ${props => {
      if (props.labelStatus === "top") {
        return `            
            background-color: inherit;
            top: -6px;
            font-size: ${Variables.font_sizes.x_small};
            &:after {
              content: "";
              display: block;
              position: absolute;
              top: 6px;
              right: 0;
              width: 100%;
              height: 1px;
              background-color: inherit;
              z-index: 1;
            }
            span {
              position: relative;
              z-index: 10;
            }
            `;
      }
    }}
  }
`;
export const BoxOpenView = styled.div`
  position: absolute;
  display: ${props => (props.status ? "block" : "none")};
  border-radius: 4px;
  box-shadow: 0 2px 14px 0 #cccccc;
  padding: 4px 0;
  width: 100%;
  min-width: 180px;
  // right: calc(100% - 24px); //todo comment for select option for accounting code
  // top: 28px;//todo comment for select option for accounting code
  right: 0;
  z-index: 99999;
  max-height: 270px;
  background-color: ${Variables.colors.complementary};
  .options {
    list-style: none;
    width: 100%;
    height: auto;
    overflow-y: auto;
    margin: 0;
    padding: 0;
    padding-bottom: 16px;
    li {
      min-height: 42px;
      padding: 6px 8px;
      display: flex;
      align-items: center;
      margin: 2px 0;
      cursor: pointer;
      font-size: ${Variables.font_sizes.medium};
      &:hover {
        background-color: ${Variables.colors.complementary_200};
      }
    }
  }
`;

export const Icon = styled.i`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:before {
    margin: 0;
    color: ${Variables.colors.complementary_800};
  }
`;
export const ControlsIcon = styled(Icon)`
  width: 40px;
  height: 40px;
  opacity: ${props => (props.className.includes("disabled") ? "0.3" : "1")}    
  position: absolute;
  left: 0;
  &:before {
    font-size: 8px !important;
  }
`;

export const BoxCloseView = styled.div`
  border-radius: 4px;
  border: ${props =>
    props.hasBorder ? "1px solid " + Variables.colors.complementary_450 : 0};

  padding: 12px 0 12px 48px;
  cursor: pointer;
  font-size: ${Variables.font_sizes.x_medium};
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 10;

  .loading-container {
    width: 40px;
    height: 40px;
    position: absolute;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .spinner {
      margin: 0;
    }
    & {
      margin: 0;
    }
  }
  .component-icon {
    padding-left: 8px;
    i {
      display: flex;
      &:before {
        margin: 0;
        color: ${props =>
          props.mode ? COLORS[props.mode].color : COLORS.normal.color};
      }
      &.small {
        &:before {
          font-size: ${Variables.font_sizes.little};
        }
      }
      &.big {
        &:before {
          font-size: ${Variables.font_sizes.small};
        }
      }
    }
  }
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  height: 100%;
  opacity: ${props => (props.className.includes("disabled") ? "0.3" : "1")};
  .selected {
    display: flex;
    color: ${Variables.colors.complementary_700};
    width: 100%;
    justify-content: flex-start;
    align-items: center;
  }
`;
